<form [formGroup]="mainForm" *ngIf="loaded">
    <h1 mat-dialog-title>{{ 'COMPANY_USER_ROLE_DIALOG.TITLE' | translate }}</h1>
    <div mat-dialog-content>

        <app-search [title]="'COMPANY_USER_ROLE_DIALOG.COMPANY_LABEL' | translate" formControlName="company" [showAddButton]="false" [inlineButtons]="false" [isAllowSearch]="true" [config]="searchCompanyConfig"
        ></app-search>

        <mat-form-field appearance="outline" class="width-max">
            <mat-label>{{ 'COMPANY_USER_ROLE_DIALOG.ROLE_LABEL' | translate }}</mat-label>
            <mat-select formControlName="roleId" disableOptionCentering class="drop-fix">
                <mat-option *ngFor="let item of roleList" [value]="item.id">{{ item.name | roleDisplayName }}</mat-option>
            </mat-select>
            <mat-error msg></mat-error>
        </mat-form-field>

    </div>
    <div mat-dialog-actions class="flex-h flex-end">
      <button mat-flat-button color="primary" [disabled]="mainForm.invalid" (click)="ok()" type="submit">{{ 'GENERAL.OK' | translate }}</button>
      <button mat-flat-button color="accent" [mat-dialog-close]>{{ 'GENERAL.CANCEL' | translate }}</button>
    </div>
  </form>
